import React from "react";
import "./Tootle.css";

export default function Tootle() {
  return (
    <section className="tootle-section position-relative overflow-hidden d-flex align-items-center justify-content-center">

      {/* Islamic Pattern */}
      <div className="pattern"></div>

      {/* Floating Lanterns */}
      <div className="lantern lantern-left">
        <i className="bi bi-stars"></i>
      </div>

      <div className="lantern lantern-right">
        <i className="bi bi-stars"></i>
      </div>

      {/* Main Content */}
      <div className="container text-center position-relative content">

        <p className="arabic">
          ﷽
        </p>

        <h1 className="mission-title">
          Misbahi Mission
        </h1>

        <div className="divider">
            <span></span>
            <i className="bi bi-star-fill"></i>
            <span></span>
        </div>

        <p className="mission-subtitle">
          Serving Humanity Through Faith, Education & Welfare
        </p>

      </div>

      {/* Decorative Glow */}
      <div className="glow glow1"></div>
      <div className="glow glow2"></div>

      {/* Mosque Skyline */}
      <div className="mosque"></div>

    </section>
  );
}